var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.img}},[_c('v-card',{staticClass:"vh-100 d-flex justify-center align-center transparent",attrs:{"flat":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }